import { render, staticRenderFns } from "./ProgramPageInformation.vue?vue&type=template&id=fd42aebc"
import script from "./ProgramPageInformation.vue?vue&type=script&lang=js"
export * from "./ProgramPageInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports